export default __webpack_public_path__ + "static/media/Magadhi_bm_1.faba2516.mp3";